// Shared option lists for the standard user profile fields, used by
// Signup, Account settings, and the profile verification modal.

export const TITLE_OPTIONS = ['Mr.', 'Mrs.', 'Ms.', 'Mx.', 'Dr.'];

export const GENDER_OPTIONS = ['Female', 'Male', 'Non-binary', 'Prefer to self-describe', 'Prefer not to say'];

// Option lists mirror the clock-hours application form blocks
// (components.content) so answers stay comparable with the lead-form
// metadata written under the same user_metadata keys.
export const YEARS_TEACHING_OPTIONS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17+', 'This does not apply'];
export const DEGREE_OPTIONS = ['AA', 'BA', 'MA', 'PHD', 'This does not apply'];
export const HOURS_COLUMN_OPTIONS = ['+0', '+15', '+30', '+45', '+60', '+90', '+135', '+155', 'This does not apply'];
